// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `day`
};

const de_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `Tag`
};

const es_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `día`
};

const fr_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `jour`
};

const fi_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `päivä`
};

const hi_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `दिन`
};

const ja_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `日`
};

const nl_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `dag`
};

const pt_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `dia`
};

const ro_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `zi`
};

const th_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `วัน`
};

const ur_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `دن`
};

const zh_hant1_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `天`
};

const da_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `dag`
};

const it_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `giorno`
};

const vn_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `ngày`
};

const ko_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `일`
};

const tr_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `gün`
};

const lv_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `diena`
};

const ar_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `يوم`
};

const bs_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `dan`
};

const sl_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `dan`
};

const id_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `hari`
};

const sv_widget_time_day = /** @type {(inputs: {}) => string} */ () => {
	return `dag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_time_day = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_time_day(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_time_day", locale)
	if (locale === "en") return en_widget_time_day(inputs)
	if (locale === "de") return de_widget_time_day(inputs)
	if (locale === "es") return es_widget_time_day(inputs)
	if (locale === "fr") return fr_widget_time_day(inputs)
	if (locale === "fi") return fi_widget_time_day(inputs)
	if (locale === "hi") return hi_widget_time_day(inputs)
	if (locale === "ja") return ja_widget_time_day(inputs)
	if (locale === "nl") return nl_widget_time_day(inputs)
	if (locale === "pt") return pt_widget_time_day(inputs)
	if (locale === "ro") return ro_widget_time_day(inputs)
	if (locale === "th") return th_widget_time_day(inputs)
	if (locale === "ur") return ur_widget_time_day(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_time_day(inputs)
	if (locale === "da") return da_widget_time_day(inputs)
	if (locale === "it") return it_widget_time_day(inputs)
	if (locale === "vn") return vn_widget_time_day(inputs)
	if (locale === "ko") return ko_widget_time_day(inputs)
	if (locale === "tr") return tr_widget_time_day(inputs)
	if (locale === "lv") return lv_widget_time_day(inputs)
	if (locale === "ar") return ar_widget_time_day(inputs)
	if (locale === "bs") return bs_widget_time_day(inputs)
	if (locale === "sl") return sl_widget_time_day(inputs)
	if (locale === "id") return id_widget_time_day(inputs)
	if (locale === "sv") return sv_widget_time_day(inputs)
	return "widget_time_day"
};